module.exports = __webpack_public_path__ + "static/img/11358b344ca02af8adaed4ae80265d1.89760a72.png";